import React from 'react'

interface TextAreaProps {
  id: string
  type: string
  placeholder: string
  label?: string
  value?: string
  maxLength?: number
  softLimit?: number
  showCounter?: boolean
  warningMessage?: string
  setValue: (value: string) => void
}

const TextArea = ({ id, type, placeholder, label, value, maxLength, softLimit, showCounter = false, warningMessage, setValue }: TextAreaProps): JSX.Element => {
  const currentLength = value?.length ?? 0
  const displayLimit = softLimit ?? maxLength
  const isOverSoftLimit = softLimit !== undefined && currentLength > softLimit

  return (
    <div className="w-full">
      {label && (
        <label htmlFor={id} className="block text-sm font-medium text-gray-600 mb-1">
          {label}
        </label>
      )}
      <textarea
        className="block w-full p-4 resize-y text-sm rounded-lg bg-gray-50 border border-gray-200 focus:border-none focus:outline focus:outline-2 focus:outline-teal-500"
        id={id}
        rows={16}
        placeholder={placeholder}
        maxLength={maxLength}
        value={value}
        onChange={(evt: React.ChangeEvent<HTMLTextAreaElement>) => { setValue(evt.target.value) }}
      />
      <div className="flex justify-between items-start mt-1">
        <div className="flex-1">
          {isOverSoftLimit && warningMessage && (
            <span className="text-xs text-amber-600">
              {warningMessage}
            </span>
          )}
        </div>
        {showCounter && displayLimit && (
          <span className={`text-xs ${isOverSoftLimit ? 'text-amber-500 font-medium' : 'text-gray-400'}`}>
            {currentLength}/{displayLimit}
          </span>
        )}
      </div>
    </div>
  )
}

export default TextArea
